module.exports = __webpack_public_path__ + "img/33.68d01e4e.svg";